var _path, _path2, _circle, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 9.535a5 5 0 107.072-7.07 5 5 0 00-7.072 7.07z",
    fill: "#FFE300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 2.464a5 5 0 000 7.071l7.072-7.07a5 5 0 00-7.072 0z",
    fill: "#FFFC80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.75,
    transform: "rotate(45 6 6)",
    stroke: "#FFE300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.977 6.76l2.951-2.952a.625.625 0 11.884.884L5.42 8.086a.625.625 0 01-.884 0L3.058 6.609a.625.625 0 11.884-.884L4.977 6.76z",
    fill: "#2C3137"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Medium_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgMedium;